import { analyticsUtils } from 'utils/analytics-utils';

/**
 * Событие должно срабатывать при попадании всего соответствующего блока во viewport.
 */

export const gaShowElement = ({ title }: { title: string }) =>
  analyticsUtils.sendEvent('GA:show', {
    elementType: 'block',
    elementBlock: 'productDetail / calc',
    elementName: title, // передаваемое значение
    elementText: 'Подсказка',
  });
